module.exports = __webpack_public_path__ + "img/App_AuthPoker.359452c8.png";